import JsxParser from 'react-jsx-parser';
import { Link } from 'react-router-dom';
import ReconnectingWebSocket from 'reconnecting-websocket';
import { toast } from '@utilities';
import {
  updateCustomGroupStatus,
  updateFlowStatus,
  updateNotificationCenter,
  updateReportBanner,
  updateReportStatus,
  updateReportSurveyGptJob,
  updateSurveyQuestionsGptStatus,
  updateSurveyValidationStatus,
  updateTabProgress,
  websocketConnect,
  websocketConnected,
  websocketDisconnect,
  websocketDisconnected,
} from '@redux/slices/websocket';

const websocketMiddleware = () => {
  let socket = null;

  const onOpen = (store) => () => {
    store.dispatch(websocketConnected());
  };

  const onClose = (store) => () => {
    store.dispatch(websocketDisconnected());
  };

  const onMessage = (store) => (event) => {
    const payload = JSON.parse(event?.data);
    const { is_toast: isToast, message, status = null } = payload?.data;

    const displayToast = () => {
      const toastHandler =
        {
          error: toast.error,
          success: toast.success,
        }[status] || toast;

      toastHandler(
        <p>
          <JsxParser
            components={{
              a: ({ children, download, href }) => {
                return download ? (
                  <a download href={window.location.origin + href}>
                    {children}
                  </a>
                ) : (
                  <Link to={href}>{children}</Link>
                );
              },
            }}
            jsx={message}
            renderInWrapper={false}
          />
        </p>
      );
    };

    switch (payload?.data?.type) {
      case 'banner':
        store.dispatch(updateReportBanner(payload));
        break;
      case 'customgroup':
        store.dispatch(updateCustomGroupStatus(payload));
        break;
      case 'default':
        if (isToast === true) {
          displayToast();
        }
        break;
      case 'flow':
        store.dispatch(updateFlowStatus(payload));
        break;
      case 'job':
        store.dispatch(updateReportStatus(payload));
        break;
      case 'jobitem':
        store.dispatch(updateTabProgress(payload));
        break;
      case 'notification_center':
        if (isToast === true) {
          displayToast();
        }
        store.dispatch(updateNotificationCenter(payload));
        break;
      case 'survey_validation':
        store.dispatch(updateSurveyValidationStatus(payload));
        break;
      case 'surveygptjob':
        store.dispatch(updateSurveyQuestionsGptStatus(payload));
        if (payload?.data?.job_id) {
          store.dispatch(updateReportSurveyGptJob(payload));
        }
        break;
      default:
        break;
    }
  };

  return (store) => (next) => (action) => {
    switch (action.type) {
      case websocketConnect.type:
        if (socket !== null) {
          socket.onclose = null;
          socket.close();
        }

        socket = new ReconnectingWebSocket(action.payload);

        socket.onmessage = onMessage(store);
        socket.onclose = onClose(store);
        socket.onopen = onOpen(store);

        break;
      case websocketDisconnect.type:
        if (socket !== null) {
          socket.close();
        }
        socket = null;

        break;
      default:
        return next(action);
    }
  };
};

export default websocketMiddleware();
